<app-panel
  title="Dodawanie nowego pojazdu">
  <div class="relative size-full bg-surface-100 ring-1 ring-surface-200 rounded-xl p-3">

    @if (vehicleFacade.isLoading()) {
      <app-loading></app-loading>
    }

    <p-stepper [(value)]="activeStep" class="flex flex-col items-start justify-start h-full" [linear]="true">
      <p-step-list class="inline-flex items-center justify-center flex-shrink-0">
        <p-step [value]="1" class="flex flex-row flex-auto gap-2">
          <ng-template #content let-activateCallback="activateCallback" let-value="value">
            <button class="bg-transparent border-0 inline-flex flex-col gap-2" (click)="activateCallback()">
              <span class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                    [ngClass]="{'bg-primary text-primary-contrast border-primary': value <= activeStep, 'border-surface': value > activeStep}">
                    <ng-icon name="tablerCar" size="1.75rem"></ng-icon>
              </span>
            </button>
          </ng-template>
        </p-step>
        <p-step [value]="2" class="flex flex-row flex-auto gap-2">
          <ng-template #content let-activateCallback="activateCallback" let-value="value">
            <button class="bg-transparent border-0 inline-flex flex-col gap-2" (click)="activateCallback()">
              <span class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                    [ngClass]="{'bg-primary text-primary-contrast border-primary': value <= activeStep, 'border-surface text-primary bg-surface-0': value > activeStep}">
                    <ng-icon name="tablerId" size="1.75rem"></ng-icon>
              </span>
            </button>
          </ng-template>
        </p-step>
        <p-step [value]="3" class="flex flex-row flex-auto gap-2">
          <ng-template #content let-activateCallback="activateCallback" let-value="value">
            <button class="bg-transparent border-0 inline-flex flex-col gap-2" (click)="activateCallback()">
              <span class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                    [ngClass]="{'bg-primary text-primary-contrast border-primary': value <= activeStep, 'border-surface text-primary bg-surface-0': value > activeStep}">
                    <ng-icon name="tablerShieldDollar" size="1.75rem"></ng-icon>
              </span>
            </button>
          </ng-template>
        </p-step>
        <p-step [value]="4" class="flex flex-row flex-auto gap-2">
          <ng-template #content let-activateCallback="activateCallback" let-value="value">
            <button class="bg-transparent border-0 inline-flex flex-col gap-2" (click)="activateCallback()">
              <span class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                    [ngClass]="{'bg-primary text-primary-contrast border-primary': value <= activeStep, 'border-surface text-primary bg-surface-0': value > activeStep}">
                    <ng-icon name="tablerEngine" size="1.75rem"></ng-icon>
              </span>
            </button>
          </ng-template>
        </p-step>
        <p-step [value]="5" class="flex flex-row flex-auto gap-2">
          <ng-template #content let-activateCallback="activateCallback" let-value="value">
            <button class="bg-transparent border-0 inline-flex flex-col gap-2 max-w-12" (click)="activateCallback()">
              <span class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                    [ngClass]="{'bg-primary text-primary-contrast border-primary': value <= activeStep, 'border-surface text-primary bg-surface-0': value > activeStep}">
                    <ng-icon name="tablerMapPin" size="1.75rem"></ng-icon>
              </span>
            </button>
          </ng-template>
        </p-step>
        <p-step [value]="6" class="flex flex-row flex-auto gap-2">
          <ng-template #content let-activateCallback="activateCallback" let-value="value">
            <button class="bg-transparent border-0 inline-flex flex-col gap-2 max-w-12" (click)="activateCallback()">
              <span class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                    [ngClass]="{'bg-primary text-primary-contrast border-primary': value <= activeStep, 'border-surface text-primary bg-surface-0': value > activeStep}">
                    <ng-icon name="tablerCameraPlus" size="1.75rem"></ng-icon>
              </span>
            </button>
          </ng-template>
        </p-step>
      </p-step-list>
      <p-step-panels class="bg-surface-0 ring-1 ring-surface-200 rounded-xl size-full overflow-hidden">
        <form [formGroup]="form" (submit)="onSubmit()"
              class="pr-2 size-full flex flex-col flex-1 min-h-0 overflow-y-auto">
          <p-step-panel [value]="1">
            <ng-template #content let-activateCallback="activateCallback">
              <div class="size-full flex flex-col items-start justify-between overflow-y-auto min-h-0"
                   formGroupName="vehicleSpecificationSection">
                <div class="size-full p-2 flex flex-col items-start justify-start gap-5">
                  <h3 class="text-xl text-surface-500">Specyfikacja pojazdu</h3>
                  <div class="w-full">
                    <p-message [severity]="'info'" [icon]="'pi pi-info-circle'" size="small">
                      Uzupełnij specyfikację pojazdu w oparciu o dane takiej jak kategoria, marka, model i numer
                      fabryczny. Dodaj informację o właścicielu (indywidualnym lub istytucjonalnym).
                    </p-message>
                  </div>

                  <app-select-input
                    class="w-full"
                    [options]="vehicleFacade.vehicleCategories$ | async"
                    label="Kategoria"
                    placeholder="Wybierz kategorię pojazdu"
                    formControlName="category"
                    [showClear]="true"
                    [filter]="true"
                    filterPlaceholder="Wyszukaj kategorię">
                  </app-select-input>

                  <div class="flex flex-row items-center w-full gap-5">
                    <app-select-input
                      class="w-full"
                      [options]="vehicleFacade.vehicleBrands$ | async"
                      label="Marka"
                      placeholder="Wybierz markę pojazdu"
                      formControlName="brand"
                      [showClear]="true">
                    </app-select-input>
                    <app-select-input
                      class="w-full"
                      [options]="vehicleFacade.vehicleModels$ | async"
                      label="Model"
                      placeholder="Wybierz model pojazdu"
                      formControlName="model"
                      [showClear]="true">
                    </app-select-input>
                  </div>

                  <div class="flex flex-row items-center w-full gap-5">
                    <app-select-input
                      class="w-full"
                      [lazy]="true"
                      [options]="vehicleFacade.vehicleOwners$ | async"
                      (onLoadMore)="onVehicleOwnerLazyLoad($event)"
                      formControlName="owner"
                      label="Właściciel pojazdu"
                      placeholder="Wybierz właściciela pojazdu"
                      [virtualScroll]="true"
                      [filter]="true"
                      [showClear]="true">
                    </app-select-input>
                  </div>

                  <div class="flex flex-row items-center w-full gap-5">
                    <app-date-input
                      class="w-full"
                      label="Data przyjęcia"
                      labelMode="static"
                      [showClear]="true"
                      [untilNow]="true"
                      formControlName="transferDate"
                      [showTime]="true">
                    </app-date-input>
                    <app-text-input
                      class="w-full"
                      formControlName="transferringPerson"
                      label="Osoba zdająca pojazd"
                      labelMode="static"
                      type="text">
                    </app-text-input>
                  </div>
                </div>

                <div class="flex pt-6 justify-end w-full">
                  <p-button
                    [disabled]="!vehicleSpecificationSection.valid"
                    rounded
                    label="Przejdź dalej"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    (onClick)="activateCallback(2)"/>
                </div>
              </div>
            </ng-template>
          </p-step-panel>

          <p-step-panel [value]="2">
            <ng-template #content let-activateCallback="activateCallback">
              <div class="size-full flex flex-col items-start justify-start"
                   formGroupName="vehicleIdentificationSection">
                <div class="size-full overflow-y-auto p-2 flex flex-col items-start justify-start gap-5">
                  <h3 class="text-xl text-surface-500">Identyfikacja pojazdu</h3>
                  <div class="py-2 w-full">
                    <p-message [severity]="'info'" [icon]="'pi pi-info-circle'">
                      Uzupełnij dane identyfikacyjne pojazdu. Pamiętaj, że nie każdy pojazd musi być wyposażony w
                      poniższy zestaw danych.
                    </p-message>
                  </div>

                  @if (isVehicleRegisterable()) {
                    <div class="flex flex-row items-center w-full gap-5">
                      <app-text-input
                        formControlName="vin"
                        label="Numer VIN"
                        labelMode="static"
                        class="w-full"
                        [maxlength]="17"
                        [noWhitespace]="true"
                        [uppercase]="true">
                      </app-text-input>

                      <app-text-input
                        formControlName="registrationPlate"
                        label="Numer rejestracyjny"
                        labelMode="static"
                        class="w-full"
                        [noWhitespace]="true"
                        [uppercase]="true">
                      </app-text-input>
                    </div>

                    <app-text-input
                      formControlName="numberAndSeriesOfRegistrationCard"
                      label="Seria i numer dowodu rejestracyjnego"
                      labelMode="static"
                      class="w-full">
                    </app-text-input>

                  } @else {
                    <app-text-input
                      class="w-full"
                      formControlName="factoryNumber"
                      label="Numer fabryczny"
                      labelMode="static"
                      type="text">
                    </app-text-input>
                    <app-text-input
                      class="w-full"
                      formControlName="identificationNumber"
                      label="Numer identyfikacyjny"
                      labelMode="static"
                      type="text">
                    </app-text-input>
                  }
                </div>

                <div class="inline-flex pt-6 justify-end w-full gap-2">
                  <p-button
                    severity="secondary"
                    rounded
                    label="Powrót"
                    icon="pi pi-arrow-left"
                    iconPos="left"
                    (onClick)="activateCallback(1)"/>
                  <p-button
                    [disabled]="!vehicleIdentificationSection.valid"
                    rounded
                    label="Przejdź dalej"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    (onClick)="activateCallback(3)"/>
                </div>
              </div>
            </ng-template>
          </p-step-panel>

          <p-step-panel [value]="3">
            <ng-template #content let-activateCallback="activateCallback">
              <div class="size-full flex flex-col items-start justify-start"
                   formGroupName="vehicleInsuranceSection">
                <div class="size-full overflow-y-auto p-2 flex flex-col items-start justify-start gap-5">
                  <h3 class="text-xl text-surface-500">Ubezpieczenie pojazdu</h3>
                  <div class="py-2 w-full">
                    <p-message [severity]="'info'" [icon]="'pi pi-info-circle'">
                      Uzupełnij dane ubezpieczeniowe pojazdu
                    </p-message>
                  </div>

                  <div class="flex items-center">
                    <p-toggleswitch
                      inputId="has-insurance"
                      name="hasInsurance"
                      formControlName="hasInsurance"/>
                    <label for="has-insurance" class="ml-2">
                      Pojazd posiada polisę ubezpieczeniową
                    </label>
                  </div>

                  @if (hasInsurance()) {
                    <div class="flex flex-row items-center w-full gap-5">
                      <app-date-input
                        class="w-full"
                        label="Data ważności polisy ubezpieczeniowej"
                        labelMode="static"
                        [showClear]="true"
                        formControlName="insuranceTerminationDate">
                      </app-date-input>
                      <!--                      <app-date-input-->
                      <!--                        class="w-full"-->
                      <!--                        label="Data ważności zweryfikowanej w UFG polisy ubezpieczeniowej"-->
                      <!--                        labelMode="static"-->
                      <!--                        [showClear]="true"-->
                      <!--                        formControlName="ufgInsuranceTerminationDate">-->
                      <!--                      </app-date-input>-->
                    </div>
                  }

                </div>

                <div class="inline-flex pt-6 justify-end w-full gap-2">
                  <p-button
                    severity="secondary"
                    rounded
                    label="Powrót"
                    icon="pi pi-arrow-left"
                    iconPos="left"
                    (onClick)="activateCallback(2)"/>
                  <p-button
                    [disabled]="!vehicleInsuranceSection.valid"
                    rounded
                    label="Przejdź dalej"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    (onClick)="activateCallback(4)"/>
                </div>
              </div>
            </ng-template>
          </p-step-panel>

          <p-step-panel [value]="4">
            <ng-template #content let-activateCallback="activateCallback">
              <div class="size-full flex flex-col items-start justify-start"
                   formGroupName="vehicleServiceSection">
                <div class="size-full overflow-y-auto p-2 flex flex-col items-start justify-start gap-5">
                  <h3 class="text-xl text-surface-500">Dokumentacja serwisowa pojazdu</h3>
                  <div class="py-2 w-full">
                    <p-message [severity]="'info'" [icon]="'pi pi-info-circle'">
                      Uzupełnij informację o dacie ważności przeglądu technicznego

                      @if (isVehicleTachographable()) {
                        oraz dacie kontroli tachografu, jeśli dotyczy tego pojazdu
                      }
                    </p-message>
                  </div>

                  <app-date-input
                    class="w-100"
                    label="Data ważności przeglądu technicznego"
                    labelMode="static"
                    [showClear]="true"
                    formControlName="technicalInspectionTerminationDate">
                  </app-date-input>

                  @if (vehicleCategory()) {
                    @if (isVehicleTachographable()) {
                      <app-date-input
                        class="w-100"
                        label="Data kontroli tachografu"
                        labelMode="static"
                        [showClear]="true"
                        formControlName="tachographInspectionDate">
                      </app-date-input>
                    }

                    @let usageType = vehicleUsageTypeComputed();

                    @switch (usageType) {
                      @case (mileageVehicleUsageType) {
                        <app-numerical-input
                          formControlName="mileage"
                          label="Przebieg pojazdu"
                          labelMode="static"
                          class="w-100"
                          suffix=" km"
                          [useGrouping]="true"
                          [maxLength]="8">
                        </app-numerical-input>
                      }
                      @case (motoHoursVehicleUsageType) {
                        <app-numerical-input
                          formControlName="motoHours"
                          label="Przebieg pojazdu"
                          labelMode="static"
                          class="w-100"
                          suffix=" MH"
                          [useGrouping]="true"
                          [maxLength]="8">
                        </app-numerical-input>
                      }
                      @case (bothVehicleUsageType) {
                        <p-selectButton
                          [options]="vehicleUsageOptions"
                          (onChange)="selectedOtherVehiclesUsageType.set($event.value)"
                          optionLabel="label"
                          optionValue="value"
                          required
                          size="small"
                          [allowEmpty]="false">
                        </p-selectButton>

                        @if (ifOtherVehicleHasMileageUsageTypeComputed()) {
                          <app-numerical-input
                            formControlName="mileage"
                            label="Przebieg pojazdu"
                            labelMode="static"
                            class="w-100"
                            suffix=" km"
                            [useGrouping]="true"
                            [maxLength]="8">
                          </app-numerical-input>
                        } @else {
                          <app-numerical-input
                            formControlName="motoHours"
                            label="Przebieg pojazdu"
                            labelMode="static"
                            class="w-100"
                            suffix=" MH"
                            [useGrouping]="true"
                            [maxLength]="8">
                          </app-numerical-input>
                        }
                      }
                    }
                  }

                </div>
                <div class="inline-flex pt-6 justify-end w-full gap-2">
                  <p-button
                    severity="secondary"
                    rounded
                    label="Powrót"
                    icon="pi pi-arrow-left"
                    iconPos="left"
                    (onClick)="activateCallback(3)"/>
                  <p-button
                    [disabled]="!vehicleServiceSection.valid"
                    rounded
                    label="Przejdź dalej"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    (onClick)="activateCallback(5)"/>
                </div>
              </div>
            </ng-template>
          </p-step-panel>

          <p-step-panel [value]="5">
            <ng-template #content let-activateCallback="activateCallback">
              <div class="size-full flex flex-col items-start justify-start"
                   formGroupName="vehicleStorageSection">
                <div class="size-full overflow-y-auto p-2 flex flex-col items-start justify-start gap-5">
                  <h3 class="text-xl text-surface-500">
                    Lokalizacja pojazdu
                  </h3>
                  <div class="py-2 w-full">
                    <p-message [severity]="'info'" [icon]="'pi pi-info-circle'">Uzupełnij dane o miejscu
                      przechowywania
                      pojazdu
                    </p-message>
                  </div>

                  <app-select-input
                    class="w-full"
                    [lazy]="true"
                    [options]="vehicleFacade.vehicleStorages$ | async"
                    (onLoadMore)="onVehicleStoragesLazyLoad($event)"
                    formControlName="storage"
                    label="Lokalizacja pojazdu"
                    placeholder="Wybierz lokalizację pojazdu"
                    [virtualScroll]="true"
                    [filter]="true"
                    [showClear]="true">
                  </app-select-input>
                </div>
                <div class="inline-flex pt-6 justify-end w-full gap-2">
                  <p-button
                    severity="secondary"
                    rounded
                    label="Powrót"
                    icon="pi pi-arrow-left"
                    iconPos="left"
                    (onClick)="activateCallback(4)"/>
                  <p-button
                    [disabled]="!vehicleStorageSection.valid"
                    rounded
                    label="Przejdź dalej"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    (onClick)="activateCallback(6)"/>
                </div>
              </div>
            </ng-template>
          </p-step-panel>

          <p-step-panel [value]="6">
            <ng-template #content let-activateCallback="activateCallback">
              <div class="size-full flex flex-col items-start justify-start"
                   formGroupName="vehicleStorageSection">
                <div class="size-full overflow-y-auto p-2 flex flex-col items-start justify-start gap-5">
                  <h3 class="text-xl text-surface-500">
                    Dokumentacja fotograficzna pojazdu
                  </h3>
                  <div class="py-2 w-full">
                    <p-message [severity]="'info'" [icon]="'pi pi-info-circle'">
                      Uzupełnij dokumentację fotograficzną pojazdu. Ten etap formularza nie są obligatoryjny.
                    </p-message>
                  </div>

                  <div class="size-full min-h-0 overflow-x-hidden overflow-y-auto flex flex-col">
                    <p-fileupload
                      #fileUpload
                      (onSelect)="onSelect($event)"
                      (onClear)="onClearFiles()"
                      [multiple]="true"
                      accept="image/*"
                      maxFileSize="1000000"
                      [customUpload]="true"
                      mode="advanced">
                      <ng-template pTemplate="header" let-onChoose="chooseCallback" let-onClear="clearCallback">
                        <div class="w-full inline-flex items-center justify-start gap-2">
                          <p-button
                            label="Wybierz zdjęcia (10)"
                            rounded
                            icon="pi pi-images"
                            size="small"
                            (onClick)="onChoose()">
                          </p-button>
                          <p-button
                            label="Wyczyść"
                            rounded
                            outlined
                            icon="pi pi-trash"
                            severity="danger"
                            size="small"
                            (onClick)="onClear()">
                          </p-button>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="empty">
                        <div
                          class="w-full h-[300px] flex flex-col items-center justify-center gap-2 border-2 border-surface-300 border-dashed bg-surface-100 rounded-xl text-surface-500">
                          <ng-icon name="tablerUpload" size="3rem"></ng-icon>
                          <span class="text-xl font-semibold">Przeciągnij i upuść pliki</span>
                        </div>
                      </ng-template>
                    </p-fileupload>
                  </div>
                </div>
                <div class="inline-flex pt-6 justify-end w-full gap-2">
                  <p-button
                    severity="secondary"
                    rounded
                    label="Powrót"
                    icon="pi pi-arrow-left"
                    iconPos="left"
                    (onClick)="activateCallback(5)"/>
                  <p-button
                    [disabled]="!form.valid"
                    type="submit"
                    rounded
                    label="Dodaj pojazd"/>
                </div>
              </div>
            </ng-template>
          </p-step-panel>
        </form>
      </p-step-panels>
    </p-stepper>
  </div>
</app-panel>
